import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';

import { ProgressSpinner } from 'primeng/progressspinner';
import { Card } from 'primeng/card';
import { OrgaoResponse } from '@/core/api/sicom-api/registro/orgao/orgao.model';
import { LayoutService } from '@/layout/service/layout.service';
import { SelectEstado } from '@/shared/components/layout/select-estado/select-estado';

@Component({
    selector: 'app-dados-gerais',
    standalone: true,
    imports: [ProgressSpinner, Card, SelectEstado],
    templateUrl: './dados-gerais.html',
    styleUrl: './dados-gerais.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DadosGerais {
    orgao = input<OrgaoResponse | null>(null);
    uf = model<string>('DF');
    isLoading = input<boolean>(false);

    constructor(public layoutService: LayoutService) {}

    formatarData(data?: string): string {
        if (!data) {
            return '-';
        }

        const [ano, mes, dia] = data.split('-');
        if (!ano || !mes || !dia) {
            return data;
        }

        return `${dia}/${mes}/${ano}`;
    }

    valorOuTraco(valor?: string | null): string {
        return valor?.trim() || '-';
    }

    formatarCnpj(valor?: string | null): string {
        const digitos = (valor || '').replace(/\D/g, '');
        if (digitos.length !== 14) {
            return this.valorOuTraco(valor);
        }

        return `${digitos.slice(0, 2)}.${digitos.slice(2, 5)}.${digitos.slice(5, 8)}/${digitos.slice(8, 12)}-${digitos.slice(12)}`;
    }
}
